'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Parse attributes from Builder into query string
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Parser = function () {
  function Parser(builder) {
    _classCallCheck(this, Parser);

    this.builder = builder;
    this.uri = '';
  }

  // final query string


  _createClass(Parser, [{
    key: 'query',
    value: function query() {
      this.includes();
      this.appends();
      this.fields();
      this.filters();
      this.sorts();
      this.page();
      this.limit();
      this.payload();

      return this.uri;
    }

    /**
     * Helpers
     */

  }, {
    key: 'hasIncludes',
    value: function hasIncludes() {
      return this.builder.includes.length > 0;
    }
  }, {
    key: 'hasAppends',
    value: function hasAppends() {
      return this.builder.appends.length > 0;
    }
  }, {
    key: 'hasFields',
    value: function hasFields() {
      return Object.keys(this.builder.fields.fields).length > 0;
    }
  }, {
    key: 'hasFilters',
    value: function hasFilters() {
      return Object.keys(this.builder.filters.filter).length > 0;
    }
  }, {
    key: 'hasSorts',
    value: function hasSorts() {
      return this.builder.sorts.length > 0;
    }
  }, {
    key: 'hasPage',
    value: function hasPage() {
      return this.builder.pageValue !== null;
    }
  }, {
    key: 'hasLimit',
    value: function hasLimit() {
      return this.builder.limitValue !== null;
    }
  }, {
    key: 'hasPayload',
    value: function hasPayload() {
      return this.builder.payload !== null;
    }
  }, {
    key: 'prepend',
    value: function prepend() {
      return this.uri === '' ? '?' : '&';
    }

    /**
     * Parsers
     */

  }, {
    key: 'includes',
    value: function includes() {
      if (!this.hasIncludes()) {
        return;
      }

      this.uri += this.prepend() + 'include=' + this.builder.includes;
    }
  }, {
    key: 'appends',
    value: function appends() {
      if (!this.hasAppends()) {
        return;
      }

      this.uri += this.prepend() + 'append=' + this.builder.appends;
    }
  }, {
    key: 'fields',
    value: function fields() {
      if (!this.hasFields()) {
        return;
      }

      this.uri += this.prepend() + _qs2.default.stringify(this.builder.fields, { encode: false });
    }
  }, {
    key: 'filters',
    value: function filters() {
      if (!this.hasFilters()) {
        return;
      }

      this.uri += this.prepend() + _qs2.default.stringify(this.builder.filters, { encode: false });
    }
  }, {
    key: 'sorts',
    value: function sorts() {
      if (!this.hasSorts()) {
        return;
      }

      this.uri += this.prepend() + 'sort=' + this.builder.sorts;
    }
  }, {
    key: 'page',
    value: function page() {
      if (!this.hasPage()) {
        return;
      }

      this.uri += this.prepend() + 'page=' + this.builder.pageValue;
    }
  }, {
    key: 'limit',
    value: function limit() {
      if (!this.hasLimit()) {
        return;
      }

      this.uri += this.prepend() + 'limit=' + this.builder.limitValue;
    }
  }, {
    key: 'payload',
    value: function payload() {
      if (!this.hasPayload()) {
        return;
      }

      this.uri += this.prepend() + _qs2.default.stringify(this.builder.payload, { encode: false });
    }
  }]);

  return Parser;
}();

exports.default = Parser;


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-api-query/build/Parser.js
// module id = XBcn
// module chunks = 40